module.exports = __webpack_public_path__ + "static/media/olive-group-logo.3818cb8f.png";